import React from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import Head from './components/Head';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import { LOCAL_CONSTANT } from './components/localConstant';

function App() {
  return (
    <HelmetProvider>
      <Head documentName={LOCAL_CONSTANT.DOCUMENT_NAME} discription={LOCAL_CONSTANT.DISCRIPTION} />
      <div className="bg-primary">
        <Header />
        <Main />
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
